<template>
  <div class="vue-forgot-password-wrap">
    <div>
      <b-modal
      hide-footer
      id="forgot-password-modal"
      @hide="cancel"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>VT Outages - Forgot Password</h3>
        </template>
        <div class="form-container">
            <form>
                <div v-if="!resetCodeSent">
                  <div class="form-control-container">
                    <label>Please enter your username:</label>
                    <input type="text" class="hidden-input">
                    <input
                    type="text"
                    @keyup.enter="sendResetCode"
                    autocorrect="off"
                    autocapitalize="none"
                    v-model="credentials.username">
                  </div>
                  <div class="buttons-container desktop-buttons-container">
                    <b-spinner v-if="sendingCode" class="spinner"></b-spinner>
                    <div v-if="!sendingCode">
                      <b-button
                      v-on:click="sendResetCode()"
                      class="btn submit"
                      v-bind:disabled="!credentials.username">Send password reset code</b-button>
                      <span v-if="sendResetCodeApiError" class="status-message error">{{sendResetCodeApiError}}</span>
                    </div>
                  </div>
                </div>
                <div v-if="resetCodeSent">
                  <h2
                  class="verification-code-message"
                  v-if="temporaryCodeDestination">A verification code has been sent to: <span class="destination">{{temporaryCodeDestination}}</span></h2>
                  <div class="form-control-container">
                    <label>Verification code:</label>
                    <input
                    type="text"
                    @keyup.enter="changePassword"
                    autocorrect="off"
                    autocapitalize="none"
                    v-model="credentials.code">
                  </div>
                  <div class="form-control-container">
                    <label>New password:</label>
                    <input
                    type="password"
                    @keyup.enter="changePassword"
                    autocorrect="off"
                    autocapitalize="none"
                    v-on:keyup="validatePassword()"
                    v-model="credentials.newPassword">
                    <div v-if="credentials.newPassword && !newPasswordValid" class="validation-message error">{{passwordValidationInstructions}}</div>
                  </div>
                <div class="form-control-container">
                  <label>Confirm new password</label>
                  <input
                  type="password"
                  @keyup.enter="changePassword"
                  v-model="credentials.newPasswordConfirm">
                  <div v-if="credentials.newPasswordConfirm && credentials.newPasswordConfirm.length >= credentials.newPassword.length && credentials.newPassword !== credentials.newPasswordConfirm" class="validation-message error">Passwords must match</div>
                </div>
                  <div class="buttons-container desktop-buttons-container">
                    <b-spinner v-if="changingPassword" class="spinner"></b-spinner>
                    <div v-if="!changingPassword">
                      <b-button
                      class="btn submit"
                      v-on:click="changePassword()"
                      v-bind:disabled="!this.newPasswordValid || !credentials.newPassword  || !credentials.newPasswordConfirm || credentials.newPassword !== credentials.newPasswordConfirm">Change password</b-button>
                      <span v-if="changingPasswordApiError" class="status-message error">{{changingPasswordApiError}}</span>
                    </div>
                  </div>
                </div>
            </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vueMqMixin from "../mixins/VueMqMixin";
import Authentication from "@/services/authentication";
import AppConfig from "../../../resources/AppConfig.js";

export default {
  name: 'ForgotPasswordModal',
  mixins: [vueMqMixin],
  props: {
    hideModal: Function,
    forgotPasswordSuccess: Function
  },
  async created() {
    Vue.nextTick(() => this.$bvModal.show('forgot-password-modal'));
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal forgot-password isMobileOrTablet'] : ['vt-outages-modal forgot-password'];
  },
  data() {
    return {
      credentials: {},
      sendingCode: undefined,
      newPasswordValid: false,
      resetCodeSent: undefined,
      changingPassword: undefined,
      sendResetCodeApiError: undefined,
      changingPasswordApiError: undefined,
      temporaryCodeDestination: undefined,
      passwordValidationRegex: AppConfig.passwordValidationRegex,
      passwordValidationInstructions: AppConfig.passwordValidationInstructions
    }
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      validatePassword() {
        this.newPasswordValid = this.passwordValidationRegex.test(this.credentials.newPassword);
      },
      sendResetCode() {
        this.sendingCode = true;
        this.sendResetCodeApiError = undefined;

        Authentication
          .forgotPassword(this.credentials.username)
          .then(this.sendResetCodeSuccess)
          .catch(this.sendResetCodeError);
      },
      sendResetCodeSuccess(jsonData) {
        this.sendingCode = undefined;
        this.resetCodeSent = true;
        const codeDeliveryDetails = jsonData.CodeDeliveryDetails;
        if (codeDeliveryDetails && codeDeliveryDetails.Destination ) {
          this.temporaryCodeDestination = codeDeliveryDetails.Destination;
        }
      },
      sendResetCodeError(err) {
        this.sendingCode = undefined;
        if (err && err.message) {
          this.sendResetCodeApiError = err.message;
        } else {
          this.sendResetCodeApiError = 'There was a problem sending the code.';
        }
      },
      changePassword() {
        this.changingPassword = true;
        this.changingPasswordApiError = undefined;
        const username = this.credentials.username.trim();
        const code = this.credentials.code.trim();
        const newPassword = this.credentials.newPassword;

        Authentication
          .forgotPasswordSubmit(username, code, newPassword)
          .then(this.changePasswordSuccess)
          .catch(this.changePasswordError);
      },
      changePasswordSuccess() {
        this.changingPassword = undefined;
        this.forgotPasswordSuccess();
      },
      changePasswordError(err) {
        this.changingPassword = undefined;

        if (err && err.message) {
          this.changingPasswordApiError = err.message;
        } else {
          this.changingPasswordApiError = 'There was a problem changing your password.';
        }
      },
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

#forgot-password-modal{
  form{
    h2{
      &.verification-code-message{
        margin-bottom: 20px;
        font-size: 18px;

        .destination {
          font-weight: $xbold;
        }
      }
    }

    .hidden-input{
      display: none;
    }

    .form-control-container{
      .validation-message{
        margin: 20px 0;

        &.error {
          color: $red;
        }
      }
    }

    .buttons-container{
      .spinner{
        height: 40px;
        width: 40px;
        font-size: 22px;
        color: $orange;
      }

        .status-message{
          &.error{
            display: block;
            margin: 20px 0;
          }
        }
    }
  }
}
</style>
